<template>
  <div class="credentials-card-error">
    <div class="error-reason error-text">{{ errorReason }}</div>
    <div class="error-helper error-text" v-if="errorHelper">{{ errorHelper }}
      <a :href=linkUrl target="_blank" v-if="linkUrl">{{ sourceName }}</a>
    </div>
  </div>
</template>

<script>

function reasonToText(reason) {
  const reasonToTextMap = {
    PasswordExpired: 'הסיסמא לא בתוקף',
    AccountBlocked: 'החשבון נעול',
    AccountNotFound: 'החשבון לא קיים',
  };
  return reasonToTextMap[reason] || 'יש טעות בפרטים';
}

export default {
  name: 'CredentialsValidationError',
  props: [
    'checkCredentials',
    'sourceName',
    'links',
  ],
  computed: {
    errorReason() {
      return reasonToText(this.checkCredentials.reason);
    },
    errorHelper() {
      const invalidCredsReason = this.checkCredentials.reason;
      switch (invalidCredsReason) {
        case 'PasswordExpired': return 'צריך לחדש אותה באתר';
        case 'AccountBlocked': return 'צריך לשחרר אותו ולהזין שוב את הפרטים';
        case 'AccountNotFound': return 'צריך ליצור חשבון באתר';
        default: return null;
      }
    },
    linkUrl() {
      switch (this.checkCredentials.reason) {
        case 'PasswordExpired': return this.links.login || this.links.homepage;
        case 'AccountNotFound': return this.links.signup || this.links.homepage;
        default: return null;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '../../../../node_modules/base-ui/src/scss/riseup-colors';

  .credentials-card-error {
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 100%;
    color: $riseup_white;
    background: $riseup_red;
    font-size: 16px;
    text-align: center;
    height: 74px;
  }

  .error-reason {
    font-weight: bold;
  }

  .error-text {
    line-height: 19px;
  }

  a {
    color: $riseup_white;
    font-weight: bold;
  }

</style>
